import React, { useEffect, useState } from 'react';
import ModernHeader from '../components/modern/ModernHeader';
import ModernHero from '../components/modern/ModernHero';
import SponsorsBar from '../components/modern/SponsorsBar';
import QuickAccessSection from '../components/modern/QuickAccessSection';
import MarketTicker from '../components/modern/MarketTicker';
import LivePricesSection from '../components/modern/LivePricesSection';
import GrainsTicker from '../components/modern/GrainsTicker';
import NewsWithSidebar from '../components/modern/NewsWithSidebar';
import BannersSection from '../components/modern/BannersSection';
import ModernFooter from '../components/modern/ModernFooter';

const ModernHomePage = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-green-50">
      <ModernHeader scrollY={scrollY} />
      <ModernHero />
      <SponsorsBar />
      <QuickAccessSection />
      {/* <MarketTicker /> */}
      <LivePricesSection />
      <GrainsTicker />
      <NewsWithSidebar />
      <BannersSection />
      <ModernFooter />
    </div>
  );
};

export default ModernHomePage;